import { Link } from "react-router-dom";
import styled from "styled-components";

export const CollectionCardWrapper = styled(Link)`
  background: ${(props) => props.theme.bgrColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 16px;
  width: 299px;
  margin: 20px auto;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 245px;
`;

export const CollectionBannerWrapper = styled.div`
  width: 100%;
  height: 100px;
  border-radius: 6px;
  overflow: hidden;
  & img {
    width: 100%;
    height: auto;
  }
`;

export const CollectionAvatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -30px auto 0;
  background-color: ${(props) => props.theme.body};
  & img {
    width: 54px;
    height: 54px;
    border-radius: 50%;
  }
`;

export const CollectionInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  & h5 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 126.2%;
    text-align: center;
    color: ${(props) => props.theme.textColor};
    margin: 8px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
`;

export const CollectionLink = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 126.2%;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.theme.textColor};
  & a {
    color: #0088cc;
  }
`;

export const CollectionPrice = styled.div`
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 126.2%;
  margin-top: 8px;
  color: ${(props) => props.theme.textColor};
  display: flex;
  align-items: center;
  & img {
    width: 24px;
    height: 24px;
  }
`;
